import { useQuery } from '@apollo/client';
import { initQuery } from './query';
export function useGetData(options) {
    return useQuery(initQuery, options);
}
